
import { toast } from 'react-toastify';
import { GET, POST, POSTFIle } from '../http';
import { URLENUM } from '../Texts';
import LOGO from "../../Images/logo.png";


enum ErrorMsg {

  Error_401 = 'Your session has expired.',
  Error_404 = 'Page error',
  Error_500 = 'Internal server error'

}

const toast_config = {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 3000,
};

const Alerts: AlertProp = {

  show_error: (msg: string) => {
    toast.error(msg, toast_config);
  },

  show_info: (msg: string) => {
    toast.info(msg, toast_config);
  },
  show_success: (msg: string) => {
    toast.success(msg, toast_config);
  },
  show_warn: (msg: string) => {
    toast.warn(msg, toast_config);
  }

};

const Session: SessionProps = {
  save: (key, value) => {
    window.localStorage.setItem(key, value as string);
  },
  get: (key) => {
    const resp = window.localStorage.getItem(key);
    return resp as string;
  },

  delete: (key) => {
    return window.localStorage.removeItem(key);
  },
  clear: () => {
    window.localStorage.clear();
  }
};

const HttpsRequest: HttpReqProps = {
  callback: (resp: RespArgs, func: (r: RespArgs) => void) => {

    if (resp.status === -1) {
      Alerts.show_error(resp.status_msg);
    }
    else if (resp.status === -3) {
      Alerts.show_error(resp.status_msg);
    }

    func(resp);

  },
  error_func: (r: RespArgs) => {
    const code: number = r.httpcode as number;
    const error_msg: string = r.errormsg as string;

    if (code === 401) {

      Alerts.show_info(ErrorMsg.Error_401);
      let anchor = document.createElement('a')
      anchor.setAttribute("href", URLENUM.logout + "?session=timeout");
      anchor.click();

    }
    else if (code >= 500) {
      Alerts.show_error(ErrorMsg.Error_500);
    }
    else if (code === 404) {
      Alerts.show_error(ErrorMsg.Error_404);
    }
    else {
      Alerts.show_error(error_msg);
    }
  },
  get: (
    url: string, success_func: (resp: RespArgs) => void,
    auth?: Record<string, string>, args?: Record<string, string>,
    error_handler?: (resp: RespArgs) => void
  ) => {

    GET(url,
      (r: RespArgs) => HttpsRequest.callback(r, success_func),
      (r: RespArgs) => {
        HttpsRequest.error_func(r);
        if (error_handler) error_handler(r);
      },
      (auth || {}),
      (args || {})
    );
  },
  post: (
    url: string, data: Record<string, any>,
    success_func: (resp: RespArgs) => void,
    auth?: Record<string, string>,
    error_handler?: (resp: RespArgs) => void
  ) => {

    POST(
      url, data,
      (r: RespArgs) => HttpsRequest.callback(r, success_func),
      (r: RespArgs) => {
        HttpsRequest.error_func(r);
        if (error_handler) error_handler(r);
      },
      auth
    );
  },
  postfile: (
    url: string, data: Record<string, any>,
    success_func: (resp: RespArgs) => void,
    auth?: Record<string, string>,
    error_handler?: (resp: RespArgs) => void
  ) => {
    POSTFIle(
      url, data,
      (r: RespArgs) => HttpsRequest.callback(r, success_func),
      (r: RespArgs) => {
        HttpsRequest.error_func(r);
        if (error_handler) error_handler(r);
      },
      auth
    );
  }
};


const GetAuth = () => {
  return {
    Authorization: `Auth ${Session.get('token')}`
  };
};


const Round = (val: number): number => {
  return Math.round((val + 0.00001) * 100) / 100
}



const ProductName = ({size, classname}:{size:string, classname?:string})=> (
  <span className={classname || "theme_blue_text"}> <img src={LOGO} style={{width:size, height:size}} className='rounded'/>aptrackapp </span>
)


function StopFlagBanner({ address, timestamp, hours, units }: {
  address: string; timestamp: string;
  hours: number; units: string;
}): string {

  return (`
    <p class='stop_banner'>
      <span style='font-size:20px;'> <b> STOPS </b> </span> <br/><br/> 
      LOOKUP ADDRESS: <b> ${address} </b> <br/><br/>
      TIMESTAMP: ${timestamp} <br/><br/>
      TIME SPENT: ${hours} ${units} <br/><br/>
    </p>  
  `
  )
}

function hours_format(val: number) {

  let rem = val % 60;
  let hour_past = val / 60;

  if (rem > 0) {
    hour_past = (val - rem) / 60
    rem = Number(rem.toFixed(0));
    return `${hour_past} hours and ${Round(rem)} minutes ago`
  }

  return `${hour_past} hours ago`
}

function calculate_last_seen_time(lastupdate: number | null): string {
  let title_statement = 'last seen '

  if (lastupdate !== null && lastupdate < 60) {
    if (lastupdate < 1) {
      let secs = Round(lastupdate * 60);
      title_statement += `${secs} seconds ago`
    } else {
      title_statement += `${lastupdate} minutes ago`
    }

  } else if (lastupdate !== null && lastupdate > 60) {
    let hrs = hours_format(lastupdate)
    title_statement += `${hrs}`;
  } else if (lastupdate === null) {
    title_statement = 'no update today from the device';
  }

  return title_statement

}



export {
  Alerts,
  HttpsRequest,
  Session,
  GetAuth,
  Round, 
  StopFlagBanner, 
  calculate_last_seen_time, 
  ProductName
};


// https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/default_props
